import { GraphicalDataSourceConnectionPointBase } from "abweb/dto/generated/gds/GraphicalDataSourceConnectionPointBase";
export class GraphicalDataSourceConnectionPoint extends GraphicalDataSourceConnectionPointBase {
  constructor() {
    super();
  }
}
//# sourceMappingURL=GraphicalDataSourceConnectionPoint.js.map
